import React, { useState, useContext, useEffect } from "react";
import { LangCtx } from "../../../lib/context";
import DropDown from "../../../lib/ui/dropdown/Dropdown";

const MicrophoneList = (props) => {

    const [selMic, setMic] = useState('');
    const [mics, setList] = useState([]);
    const { l } = useContext(LangCtx);

    useEffect(() => {
        try {
            const objDevice = props.deviceList;
            let defaultDevice = objDevice.find(obj => obj.kind === 'audioinput');
            defaultDevice && defaultDevice.deviceId && setMic(defaultDevice.deviceId);
            let list = objDevice.filter(obj => obj.kind === 'audioinput').map(obj => {
                return { label: obj.label === '' ? l.mic + "-" + obj.deviceId.substr(-4) : obj.label, value: obj.deviceId }
            });
            setList([...list])
            defaultDevice && defaultDevice.deviceId && props.deviceHandle('mic', defaultDevice.deviceId);

        } catch (err) {
            props.handleError(err)
        }
    }, [props.deviceList]);

    const handleChange = (e) => {
        setMic(e.target.value);
        props.deviceHandle('mic', e.target.value);
    }

    return <DropDown
        placeholder={l.sel_mic}
        items={mics}
        value={selMic}
        onChange={handleChange}
        size="fullWidth"
    />
}

export default MicrophoneList;